import React, { useState } from "react";
import styled from "styled-components";

const Step6 = ({
  step,
  setStep,
  errors,
  setErrors,
  formData,
  AgentTraits,
  handleRadioChange,
}) => {
  const [wantsBackground, setWantsBackground] = useState(
    formData.background && formData.background !== "" ? "yes" : null
  );

  const handleNext = (e) => {
    e.preventDefault();
    const stepErrors = validateBackground(formData);
    if (Object.keys(stepErrors).length === 0) {
      setStep(4);
    }
  };

  const validateBackground = (data) => {
    const newErrors = {};
    if (wantsBackground === null) {
      newErrors.background = "Please select if you want to change the background";
    } else if (wantsBackground === "yes" && (!data.background || data.background === "")) {
      newErrors.background = "Please select a background";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleWantsBackgroundChange = (value) => {
    setWantsBackground(value);
    if (value === "no") {
      handleRadioChange("background", "");
    }
    // Clear errors when user makes a selection
    setErrors({});
  };

  return (
    <>
      <form className="Wrpper d-flex flex-column gap-4 max-w-[970px]">
        <div className="">
          <div className="head">
            <h5 className="m-0 fw-sbold text-[24px]">Background Settings</h5>
          </div>
          <div className="py-5 d-flex flex-column gap-10">
            {/* Yes/No Question */}
            <div className="d-flex flex-column gap-3">
              <p className="fs-5 fw-medium">Do you want to change the background?</p>
              <div className="d-flex gap-4">
                <label className="d-flex align-items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="wantsBackground"
                    checked={wantsBackground === "yes"}
                    onChange={() => handleWantsBackgroundChange("yes")}
                    className="cursor-pointer"
                    style={{ width: '16px', height: '16px' }}
                  />
                  <span>Yes</span>
                </label>
                <label className="d-flex align-items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="wantsBackground"
                    checked={wantsBackground === "no"}
                    onChange={() => handleWantsBackgroundChange("no")}
                    className="cursor-pointer"
                    style={{ width: '16px', height: '16px' }}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>

            {/* Background Options - Only show if user selected "Yes" */}
            {wantsBackground === "yes" && (
              <div className="d-flex flex-column gap-3 py-2 container">
                <h6 className="fs-5 fw-medium">Select Background</h6>
                <RadioList className="list-unstyled ps-0 mb-0 row">
                  {AgentTraits?.background?.map((val) => {
                    return (
                      <li
                        key={val._id}
                        className="position-relative col-md-4 col-6 my-2"
                      >
                        <input
                          name="background"
                          type="radio"
                          checked={formData.background === val?.titles?.title}
                          onChange={() => handleRadioChange("background", val?.titles?.title)}
                          className="position-absolute peer top-0 left-0 h-100 w-100 z-[99] cursor-pointer opacity-0"
                        />
                        <div className="h-[55px] peer-checked:bg-[#4A2CE5] peer-checked:text-white peer-checked:border-[#4A2CE5] d-flex align-items-center justify-content-center rounded-pill px-3 py-2 min-w-[162px] border border-[#868686]/30 fw-sbold" style={{fontSize: 12}}>
                          {val?.titles?.title}
                        </div>
                      </li>
                    );
                  })}
                </RadioList>
              </div>
            )}

            {errors.background && (
              <div className="text-danger text-sm mt-2">{errors.background}</div>
            )}
          </div>
        </div>
             <div className="mt-10 mx-auto w-100" style={{ maxWidth: 300 }}>

          <button
            onClick={handleNext}
            className="d-flex align-items-center justify-content-center bg-blue-600 hover:bg-blue-700 text-white h-[40px] commonBtn btn rounded-pill max-w-[377px] mx-auto transition-colors w-100"
          >
            Next
          </button>
          <button
            onClick={() => setStep(3)}
            className="d-flex align-items-center  justify-content-center  bg-blue-600 hover:bg-blue-700 text-white h-[40px] commonBtn btn rounded-pill
             max-w-[377px] mx-auto transition-colors gap -2 mt-3 w-100"
            type="button"
          >
            Back
          </button>
        </div>
      </form>
    </>
  );
};

const RadioList = styled.ul`
  li {
    input {
      cursor: pointer;
      z-index: 99;
    }
    input:checked + div {
      border-color: #9701ea !important;
      background: #9701ea;
      color: #fff;
    }
  }
`;

export default Step6;